export default function () {

  const doc     = document.documentElement, // html
    trigger     = document.querySelector('.menu-trigger'),
    menu        = document.getElementById('main-menu');
  if(trigger) {
    trigger.addEventListener('click', function () {
      doc.classList.toggle('menu-is-open');
      let isOpen = doc.classList.contains('menu-is-open');
      menu.setAttribute('aria-expanded', isOpen);
    }, false);
  }
}
